import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useEffect, useState } from 'react'
import { acknowledgeCoverage, hasAcknowledgedCoverage } from './labelingStorage'

interface LabelingCoverageDialogProps {
  /** Current session id; used to remember the acknowledgement per session */
  sessionId?: number
  /** Coverage warning from eligibility; the dialog is shown only when set */
  warning?: string
}

/**
 * One-time notice shown when entering the labeling view for a session that does
 * not cover its whole run (the run exceeds the Cell Vis sampling cap). It is
 * shown once per session; the persistent banner on the page is the ongoing
 * reminder after it is dismissed.
 */
export const LabelingCoverageDialog = ({
  sessionId,
  warning,
}: LabelingCoverageDialogProps): JSX.Element | null => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!warning || sessionId === undefined) return
    if (hasAcknowledgedCoverage(sessionId)) return
    setOpen(true)
  }, [warning, sessionId])

  if (!warning) return null

  const handleClose = () => {
    if (sessionId !== undefined) acknowledgeCoverage(sessionId)
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" data-testid="coverage-dialog">
      <DialogTitle>Not all cells are included</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mt: 1 }}>
          {warning}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LabelingCoverageDialog
